import React, { Component } from 'react';
import Dot from './Dot';

class Grid extends Component {
  row = () => {
    return (
      <div style={{ display: 'grid', justifyContent: 'space-between', gridAutoFlow: 'column' }}>
        {_.map(_.take([1, 2, 3, 4, 5, 6, 7], this.props.size), i => {
          return (
            <span key={i}>
              <Dot size={6} />
            </span>
          );
        })}
      </div>
    );
  };

  render() {
    const width = '60px';

    return (
      <div
        style={{
          width,
          height: width,
          display: 'grid',
          alignContent: 'space-between',
          justifyContent: 'stretch',
        }}
      >
        {_.map(_.take([1, 2, 3, 4, 5, 6, 7], this.props.size), i => (
          <span key={i}>{this.row()}</span>
        ))}
      </div>
    );
  }
}

export default Grid;
